module.exports = __webpack_public_path__ + "img/distance.432a52e4.svg";